// Module
var code = "<div class=\"col-sm-12\">\n    <input id=\"navScanInput\" type=\"text\" class=\"form-control input-sm no-border no-bg text-md b-t b-r b-l b-b\" ng-model=\"vm.navigationScannerInput\" placeholder=\"{{'order.scan' | translate}}\" ng-keypress=\"vm.scanInputKeyPress($event)\">\n</div>";
// Exports
module.exports = code;